<template>
    <div>
        <div style="border-bottom: 1px solid #eee;padding: 10px 0 20px 0;margin-bottom: 20px;">
            <el-checkbox v-model="form5.weizuojiancha">未做相关检测</el-checkbox>
        </div>
        <el-row class="row" v-if="showB">
            <el-col :span="1">B系</el-col>
            <el-col :span="23">
                <el-row>
                    <el-col :span="5" v-for="(items,index) in bList" :key="index">
                        <el-form-item :label="items.label" :prop="items.value">
                            <el-input :disabled="form5.weizuojiancha" type="number" step="0.0001"
                                      v-model="form5[items.value]"
                                      :class="$store.state.registration.form9.indexOf('form5_' + items.value) >= 0?'container':''"
                                      @mousewheel.native.prevent class="input-with-select"
                                      @blur="selectSet(items.value)">
                                <dingxin v-model="form5[items.select_value]" slot="prepend" :keys="items.select_value"
                                         :disabled="form5.weizuojiancha"/>
                                <span slot="append">%</span>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row class="row" v-if="showT">
            <el-col :span="1">T系</el-col>
            <el-col :span="23">
                <el-row>
                    <el-col :span="5" v-for="(items,index) in tList" :key="index">
                        <el-form-item :label="items.label" :prop="items.value">
                            <el-input :disabled="form5.weizuojiancha" type="number" step="0.0001"
                                      v-model="form5[items.value]"
                                      :class="$store.state.registration.form9.indexOf('form5_' + items.value) >= 0?'container':''"
                                      @mousewheel.native.prevent class="input-with-select"
                                      @blur="selectSet(items.value)">
                                <dingxin v-model="form5[items.select_value]" slot="prepend" :keys="items.select_value"
                                         :disabled="form5.weizuojiancha"/>
                                <span slot="append">%</span>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row class="row" v-if="showSui">
            <el-col :span="1">髓系</el-col>
            <el-col :span="23">
                <el-row>
                    <el-col :span="5" v-for="(items,index) in sList" :key="index">
                        <el-form-item :label="items.label" :prop="items.value">
                            <el-input :disabled="form5.weizuojiancha" type="number" step="0.0001"
                                      v-model="form5[items.value]"
                                      :class="$store.state.registration.form9.indexOf('form5_' + items.value) >= 0?'container':''"
                                      @mousewheel.native.prevent class="input-with-select"
                                      @blur="selectSet(items.value)">
                                <dingxin v-model="form5[items.select_value]" slot="prepend" :keys="items.select_value"
                                         :disabled="form5.weizuojiancha"/>
                                <span slot="append">%</span>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row class="row">
            <el-col :span="24">
                <el-row>
                    <el-col :span="1">&nbsp;</el-col>
                    <el-col :span="23">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="其他">
                                    <el-input :disabled="form5.weizuojiancha" v-model="form5.qita" :class="$store.state.registration.form9.indexOf('form5_qita') >= 0?'container':''"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="15">
                                <el-tooltip
                                        class="item"
                                        content="白血病相关免疫表型（Leukemia-Associated ImmunoPhenotype）"
                                        placement="top"
                                        :tabindex='-1'
                                >
                                    <el-form-item label="LAIP" prop="laip">
                                        <el-input :disabled="form5.weizuojiancha" v-model="form5.laip" :class="$store.state.registration.form9.indexOf('form5_laip') >= 0?'container':''"></el-input>
                                    </el-form-item>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <div style="padding-top:20px;margin-top:0px">
            <el-row>
                <el-col :span="4">
                    <el-dialog title="预览" :visible.sync="dialogVisible" height="70%" append-to-body>
                        <div>
                            <img :src="imageUrl" width="100%;" :style="{transform:'rotateZ('+deg+'deg)'}">
                        </div>
                        <span slot="footer" class="dialog-footer">
                              <el-button type="info" @click="rotate">旋 转</el-button>
                              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                    <el-form-item label label-width="20px" prop="fileList">
                        <el-upload
                                class="upload-demo"
                                ref="uploaddemo"
                                action="/api/case/upload/"
                                :headers="uploadHeader"
                                :onSuccess="uploadSuccess"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :file-list="form5.baogaotupian"
                                :before-remove="beforeRemove"
                        >
                            <el-button type="primary">▲报告图片上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label-width="0px">
                        <el-button type="primary" @click="wmcode('mianyibiaoxing_baogaotupian')">▲扫二维码上传</el-button>
                        <!-- <el-button type="primary" @click="getimage('mianyibiaoxing_baogaotupian')"> -->
                        <!-- <i class="el-icon-refresh"></i> -->
                        <!-- </el-button> -->
                        <!-- <erweima  :url="url" v-if="rwcode"/> -->
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-alert title="指标说明: 如果诊断时LAIP特征存在几群细胞，请均罗列描述。如果患者诊断时无典型LAIP特征，请填写“无”。如果LAIP特征不详，请填写“不详”" type="warning"
                  :closable="false" show-icon></el-alert>
        <el-dialog
                title="扫二维码上传"
                :visible.sync="model"
                width="30%"
                :before-close="handleQrcode">
            <erweima id="myxb" ref="myxb"/>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleQrcode">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import erweima from './widgets/erweima'
    import dingxin from './widgets/dingxin'
    import * as table from '../../../config/mianyibiaoxing'

    export default {
        props: ["bingli", 'addedit'],
        components: {
            erweima,
            dingxin
        },
        data() {
            let token = localStorage.getItem("token");
            return {
                model: false,
                deg: 0,
                bList: table.b,
                sList: table.s,
                tList: table.t,
                form5: this.$store.state.registration.form5,
                uploadHeader: {Authorization: `Bearer ${token}`},
                dialogVisible: false,
                imageUrl: "",
                rules: {}
            };
        },
        computed: {
            getClass() {
                // console.log("2222")
                // if (value == "阳性") return "select_yangxing";
                // else if (value == "阴性") return "select_yinxing";
                // else if (value == "未做") return "select_weixiang";
                // else if (value == "部分表达") return "select_biaoda";
                // else return "select_weixuan";
                return "select_yangxing"
            },
            showB() {
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[0] ===
                    "急性双表型白血病"
                )
                    return true;
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === "不详")
                    return true;
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[1] ===
                    "不能分型的ALL"
                )
                    return true;
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[1] != undefined
                ) {
                    return (
                        this.$store.state.registration.form2.zhenduanfenxing[1].search(
                            "B细胞"
                        ) != -1
                    );
                }
                return false;
            },
            showT() {
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[0] ===
                    "急性双表型白血病"
                )
                    return true;
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === "不详")
                    return true;
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[1] ===
                    "不能分型的ALL"
                )
                    return true;
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[1] != undefined
                ) {
                    return (
                        this.$store.state.registration.form2.zhenduanfenxing[1].search("T-ALL") != -1
                    );
                }
                return false;
            },
            showSui() {
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[0] ===
                    "急性双表型白血病"
                )
                    return true;
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === "不详")
                    return true;
                return this.$store.state.registration.form2.zhenduanfenxing[0] === "AML";
            }
        },
        methods: {
            rotate() {
                this.deg += 90;
                if (this.deg >= 360) {
                    this.deg = 0
                }
            },
            selectSet(value) {
                if (!this.form5[value]) {
                    this.form5['select_' + value] = ''
                    return
                }
                var flag = 0
                var list = ['cd79a', 'cyu', 'ccd3', 'tdt', 'mpo', 'cd117']
                for (var i = 0; i < list.length; i++) {
                    if (list[i] == value) {
                        flag = 1
                        if (this.form5[value] < 10) {
                            this.form5['select_' + value] = '阴性'
                        } else if (this.form5[value] > 80) {
                            this.form5['select_' + value] = '阳性'
                        } else if (10 <= this.form5[value] && this.form5[value] <= 80) {
                            this.form5['select_' + value] = '部分表达'
                        }
                    }
                }
                if (flag == 1) {
                    return
                }
                if (this.form5[value] < 20) {
                    this.form5['select_' + value] = '阴性'
                } else if (this.form5[value] > 80) {
                    this.form5['select_' + value] = '阳性'
                } else if (20 <= this.form5[value] && this.form5[value] <= 80) {
                    this.form5['select_' + value] = '部分表达'
                }
            },
            handleQrcode() {
                this.model = false
                this.getimage('mianyibiaoxing_baogaotupian')
            },
            quchong(data) {
                var b = []
                var tem = data
                if (this.form5.baogaotupian) {
                    tem = data.concat(this.form5.baogaotupian)
                }
                var len = tem.length;
                var i = 0;
                var arr = [];
                for (; i < len; i++) {
                    var t = tem[i];
                    if (arr.indexOf(t['id']) == -1) {
                        arr.push(t['id']);
                        b.push(t);
                    }
                }
                return b
            },
            getimage(value) {
                this.$http.get(`/case/image/list/?filed=${value}&uid=${this.$store.state.registration.form1.uuid}`)
                    .then(resp => {
                        this.form5.baogaotupian = this.quchong(resp.data.data)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            },
            guid() {
                var that = this
                return (that.S4() + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + that.S4() + that.S4());
            },
            wmcode(value) {
                var that = this
                that.model = true
                if (!that.$store.state.registration.form1.uuid) {
                    that.$store.state.registration.form1.uuid = that.guid()
                }
                if (that.$store.state.registration.form1.uuid) {
                    var url = window.location.href.split('#')[0] + 'case/uploadsredoce/?field='
                    url = url + value + '&uuid=' + that.$store.state.registration.form1.uuid+ "&token=" + localStorage.getItem('token')
                    that.$nextTick(() => {
                        that.$refs.myxb.useqrcode(url)
                    })
                } else {
                    that.$message({
                        message: '请先暂存数据，再刷新页面',
                        type: 'warning'
                    })
                }
            },
            handlePreview(e) {
                console.log(e);
                var name = e.url.split('.').pop()
                if (name == "pdf") {
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else if (name == "png" || name == "jpeg" || name == "bmp" || name == "jpg") {
                    // this.dialogVisible = true
                    // this.imageUrl = e.url
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else {
                    window.location = window.location.href.split('#')[0] + e.url.slice(1)
                }
            },
            handleRemove(file, fileList) {
                this.$store.state.registration.form5.baogaotupian = fileList;
                this.$store.dispatch({
                    type: 'delImage',
                    pk: file.id,

                }).then(resp => {
                    if (resp.data.code == 1) {
                        this.$message({message: '删除成功！', type: 'success'})
                    } else if (resp.data.code == -1) {
                        this.$message({message: resp.data.errors, type: 'error'})
                    }
                });
            },
            uploadSuccess(response, file) {
                console.log("上传文件", file.response);
                this.$store.state.registration.form5.baogaotupian.push(file.response);
            }
        },
        mounted() {
            if (this.addedit == 0) {
                this.$store.state.registration.form5.baogaotupian = []
                this.$refs.uploaddemo.clearFiles();
            }
        }
    };
</script>

<style scoped>
    /deep/ input::-webkit-outer-spin-button,
    /deep/ input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
    }

    /deep/ input[type="number"] {
        -moz-appearance: textfield;
    }

    .rows /deep/ .el-input-group__append {
        padding: 0 5px;
        background-color: #fff;
        font-size: 10px;
        border-left: 0;
    }

    .row /deep/ .el-input-group__append,
    .row /deep/ .el-input-group__prepend {
        padding: 0 5px;
        background-color: #fff;
        font-size: 10px;
    }

    /deep/ .el-form-item__label {
        font-size: 13px;
    }

    .el-col-4 {
        font-size: 14px;
    }

    .row /deep/ .el-input__inner {
        padding: 0 5px;
    }

    .row {
        margin: 20px 0;
        border-bottom: 1px solid #eee;
    }

    /deep/ .el-select .el-input {
        width: 80px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    /deep/ .el-input-group__append .el-button, .el-input-group__append .el-select, .el-input-group__prepend .el-button, .el-input-group__prepend .el-select {
        display: inline-block;
        margin: -5px 10px;
        font-size: small;
    }

    .container /deep/ .el-input__inner {
        color: red;
    }

</style>
